export default {
  address: 'Address',
  city: 'City',
  companyAutocomplete: 'Enter the address',
  country: 'Country',
  fillManually: 'Fill in manually',
  search: 'Search for address',
  streetAndNumber: 'Street and house number',
  zip: 'ZIP'
}



// WEBPACK FOOTER //
// ./src/i18n/en/address.js